module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/blank-57cf52ec73794fd0f98f40c33840785a.svg";